var initialState = {};

import { RECEIVE_HELLO } from "lib/shared/ActionUtility";

function internal(state = initialState, action) {
	switch (action.type) {

	case RECEIVE_HELLO:
		return _.extend({}, state, { hello: action.data });

	default:
		return state
	}
}

module.exports = {
	internal
};


// WEBPACK FOOTER //
// ./modules/lib/reducers/InternalReducer.js